import axios from "axios";
import store from "@/store";
const qs = require('qs')

// export const baseURL = 'https://60.30.57.78:8100/'
export const baseURL = 'http://112.124.4.129:8100/'
const instance = axios.create({
  baseURL,
  timeout: 5000
})

export default (url, reqData) => {
  if (!reqData) reqData = {};
  reqData.token = store.getters.getToken
  return instance({
    url, method: 'post', data: qs.stringify(reqData)
  })
}